import styled from "@emotion/styled";
import { Form } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { FC } from "react";
import ProductWysiwyg from "../EditorWysiwyg";

interface ProductDescriptionFormProps {
  is_active: boolean;
  content: string;
  setContent: (content: string) => void;
}

const ProductDescriptionForm: FC<ProductDescriptionFormProps> = ({
  is_active,
  content,
  setContent,
}) => {
  const handleContentChange = (text: string) => {
    setContent(text);
  };

  return (
    <FormWrapper>
      <Form.Item
        label="รายละเอียดสินค้า"
        name="description"
        required={is_active}
        rules={[{ required: is_active, message: "กรุณากรอกคำอธิบายสินค้า" }]}
      >
        <ProductWysiwyg
          content={content}
          onContentChange={handleContentChange}
        ></ProductWysiwyg>
      </Form.Item>
    </FormWrapper>
  );
};

export default ProductDescriptionForm;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 2px 20px;
  border-radius: 8px;
`;
